document.addEventListener('DOMContentLoaded', () => {
  initVariantPicker();
  initCartSubmit();
  initStickyHeader();
  initBuyOptions();
});

// ─── Buy options (3-button direct checkout) ────────────────────────────────────

function initBuyOptions() {
  const container = document.querySelector('.buy-options');
  if (!container) return;

  const processingLabel = container.dataset.processingLabel || 'Wird verarbeitet …';

  container.querySelectorAll('.btn-buy').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.disabled) return;

      const ids = (btn.dataset.variants || '')
        .split(',')
        .map(s => parseInt(s, 10))
        .filter(v => v > 0);

      const plans = (btn.dataset.sellingPlans || '')
        .split(',')
        .map(s => parseInt(s, 10) || 0);

      if (!ids.length) return;

      const items = ids.map((id, i) => {
        const item = { id, quantity: 1 };
        if (plans[i] && plans[i] > 0) item.selling_plan = plans[i];
        return item;
      });

      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = processingLabel;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
        .then(r => r.json().then(body => ({ ok: r.ok, body })))
        .then(({ ok, body }) => {
          if (!ok) {
            console.error('Cart add failed:', body);
            throw new Error(body.description || body.message || 'cart add failed');
          }
          window.location.href = '/checkout';
        })
        .catch(err => {
          btn.disabled = false;
          btn.textContent = original;
          alert(err.message || 'Hinzufügen fehlgeschlagen.');
        });
    });
  });
}

// ─── Variant picker ────────────────────────────────────────────────────────────

function initVariantPicker() {
  const form = document.getElementById('product-form');
  if (!form) return;

  const radios = form.querySelectorAll('.option-card input[type=radio]');
  const priceEl = form.querySelector('.js-price');
  const submitBtn = document.getElementById('add-to-cart-btn');

  radios.forEach(radio => {
    radio.addEventListener('change', () => {
      // Update selected card styles
      form.querySelectorAll('.option-card').forEach(card => card.classList.remove('selected'));
      radio.closest('.option-card').classList.add('selected');

      // Update price bar
      if (priceEl && radio.dataset.price) {
        priceEl.textContent = radio.dataset.price;
      }

      // Update submit availability
      if (submitBtn) {
        const available = radio.dataset.available !== 'false';
        submitBtn.disabled = !available;
        if (!available) {
          submitBtn.textContent = submitBtn.dataset.soldOut || 'Ausverkauft';
        } else {
          submitBtn.textContent = submitBtn.dataset.addToCart || 'In den Warenkorb';
        }
      }
    });
  });

  // Store original labels for reset
  if (submitBtn) {
    submitBtn.dataset.addToCart = submitBtn.textContent.trim();
    submitBtn.dataset.soldOut = 'Ausverkauft';
  }
}

// ─── Cart submit feedback ──────────────────────────────────────────────────────

function initCartSubmit() {
  const form = document.getElementById('product-form');
  if (!form) return;

  form.addEventListener('submit', () => {
    const btn = document.getElementById('add-to-cart-btn');
    if (btn && !btn.disabled) {
      btn.disabled = true;
      btn.textContent = 'Wird hinzugefügt …';
    }
  });
}

// ─── Sticky header shadow ──────────────────────────────────────────────────────

function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      header.style.borderBottomColor = entry.isIntersecting
        ? 'var(--gray-lighter)'
        : 'var(--gray-light)';
    },
    { rootMargin: '-60px 0px 0px 0px', threshold: 0 }
  );

  const sentinel = document.createElement('div');
  sentinel.style.height = '1px';
  document.body.prepend(sentinel);
  observer.observe(sentinel);
}
